import { render, staticRenderFns } from "./ProductPurchaseModal.vue?vue&type=template&id=10b0c0f7&scoped=true"
import script from "./ProductPurchaseModal.vue?vue&type=script&lang=ts"
export * from "./ProductPurchaseModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductPurchaseModal.vue?vue&type=style&index=0&id=10b0c0f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0c0f7",
  null
  
)

export default component.exports